module.exports = __webpack_public_path__ + "img/book-06.0967d054.png";